

<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: "App",
  created: () => {
  }
};
</script>

<style>
#app{
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue